var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"column is-6"},[_c('router-link',{staticClass:"column",attrs:{"to":{ name: 'Topic', params: { topicId: _vm.topic.slug }}}},[_c('span',[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v("\n    "+_vm._s(_vm.pageSummary)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }